import { AwesomeEvent, ComponentAPI, Value } from '@philips-emr/tws-core';
import { Renderable, RenderEventListener, SubmitEventListener } from '@philips-emr/tws-core/lib/component/types';

import { HpmsCustomCardAPIState, HpmsCustomCardEventListener, HpmsCustomCardMenuRenderEventListener, HpmsCustomCardType } from '../../types';

export const DYNAMIC_CONTENT_TYPE = 'hpms-custom-card-dynamic-content';
export const ACTION_TYPE = 'hpms-custom-card-action';

export default class HpmsCustomCardApi extends ComponentAPI<HpmsCustomCardAPIState> implements HpmsCustomCardType<Record<string, Value>>, Renderable {
  /** @event */
  @AwesomeEvent
  onDynamicContentRender = new RenderEventListener();

  /** @event */
  @AwesomeEvent
  onCreateOption = new HpmsCustomCardMenuRenderEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onOptionClick = new HpmsCustomCardEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onCreateMenu = new HpmsCustomCardMenuRenderEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onRenderAction = new RenderEventListener();

  /** @event */
  @AwesomeEvent
  onSubmitCard = new SubmitEventListener();

  setEditing(editing: boolean): void {
    this.setState({ ...this.state, editing });
  }

  getEditing(): boolean {
    return this.state.editing;
  }

  getRecord(): Record<string, Value> {
    return this.state.data;
  }

  setBackground(background: string): void {
    this.setState({ background });
  }

}
